var MENU = (function () {
  function init() {
    const nav = document.querySelector(".c-nav");
    const toggle = document.querySelector(".c-nav__toggle");

    toggle.addEventListener("click", function () {
      if (nav.classList.contains("is-active")) {
        nav.classList.remove("is-active");
      } else {
        nav.classList.add("is-active");
      }
    });

    document.addEventListener("click", function (e) {
      if (!e.target.closest(".c-nav")) {
        nav.classList.remove("is-active");
      }
    });
  }

  return {
    init: init,
  };
})();
